import React, { useRef,  useState } from "react";
import DragScroll from './../../../node_modules/dragscroll/dragscroll';
import { useSelector } from 'react-redux';
import {MODIMAGEPATH} from './../api';


const TnTempSlider = () => {

    const webcam = useSelector((store)=>store.webcam);
    var {activeCamera, 
        weatherData} = webcam;
    const wdata = weatherData['cam'+activeCamera];

    const ref = useRef(null);
    const scroll = (scrollOffset) => {
        ref.current.scrollLeft += scrollOffset;
    };

    // const [loaded, setloaded] = useState(false);

    // const stuffLoaded = () => {
    //     setTimeout(() => {
    //         setloaded(true);    
    //     }, 2000)
        
    // }

    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };

    const handleMouseOut = () => {
        setIsHovering(false);
    };

    
    return<>
    <div className="weathersmallmod">
          
                <div className="weathersmall_arrows">
                    <span className="weathersmall_arrows_inner weathersmall_arrows_left" 
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    onClick={() => scroll(-60)}></span>
                    <span className="weathersmall_arrows_inner weathersmall_arrows_right" 
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    onClick={() => scroll(60)}></span>
                </div>

                <div className="weathersmallmod_inner dragscroll" 
                style={{'scrollBehavior': isHovering ? 'smooth' : '',}} 
                ref={ref}
                >
                    {wdata?.Forecast_hourly?.Temperature?.map((temp,key)=>{
                        //console.log(wdata);
                        var localTime = wdata?.Forecast_hourly?.ForecastTimes_LocalTime[key];
                        var date_time = (typeof localTime !== 'undefined') ? localTime.split('T') : [];
                        let date = (typeof date_time[0] !== 'undefined') ? date_time[0] : '';
                        var time = (typeof date_time[1] !== 'undefined') ? date_time[1].split('+')[0] : '';
                        let imageIcon = wdata?.Forecast_hourly?.Icon[key];
                        if(imageIcon){
                            imageIcon = imageIcon.replace(".png", ".svg");
                        }
                        return (
                            <div key={key} className="weathersmallin">
                                <img src={MODIMAGEPATH + "svg/" + imageIcon } alt="" /> 
                                <h6>{time}</h6>
                                <span className="scrolltempsp">{temp} {wdata?.Forecast_hourly?.Temperature_Unit}</span>
                                <p>{wdata?.Forecast_hourly?.WindSpeed[key]} {wdata?.Forecast_hourly?.WindSpeed_Unit}</p>
                            </div>
                        )
                    })}
                </div>
            </div>

       
    </>
}

export default TnTempSlider;